import type { ApiKeyId, StoreId } from "@KassaroAB/shared/types/ids";
import type {
  RestApiClient,
  RestCreateApiClient,
  RestCreatedApiClient,
} from "@KassaroAB/shared/types/apiKey";
import { api } from "../utils/api";

export const getApiClientsApi = async (
  storeId: StoreId,
): Promise<RestApiClient[]> => api.get(`stores/${storeId}/apiClients`);

export const createApiClientApi = async (
  storeId: StoreId,
  data: RestCreateApiClient,
): Promise<RestCreatedApiClient> =>
  api.post(`stores/${storeId}/apiClients`, data);

export const revokeApiClientApi = async (
  storeId: StoreId,
  apiClientId: ApiKeyId,
): Promise<void> =>
  api.post(`stores/${storeId}/apiClients/${apiClientId}/revoke`, {});

export const deleteApiClientApi = async (
  storeId: StoreId,
  apiClientId: ApiKeyId,
): Promise<void> => api.delete(`stores/${storeId}/apiClients/${apiClientId}`);
